import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { IsZoneContent } from '../../components'

export const withSpaComponentWrapper = (Component) => {
  const componentDisplayName =
    Component?.displayName || Component?.name || 'Component'

  const Wrapped = (props) => {
    const { page, component } = props

    const handleError = (error, info) => {
      // Includes both runtime stack and React component hierarchy stack.
      console.error(
        `[withSpaComponentWrapper] Error while rendering ${componentDisplayName}`,
        {
          error,
          message: error?.message,
          stack: error?.stack,
          componentStack: info?.componentStack,
          page,
          component,
          props,
        }
      )
    }

    return (
      <div className="component-wrapper">
        <ErrorBoundary fallbackRender={() => null} onError={handleError}>
          <IsZoneContent page={page} component={component}>
            <Component {...props} page={page} component={component} />
          </IsZoneContent>
        </ErrorBoundary>
      </div>
    )
  }

  Wrapped.displayName = componentDisplayName

  return Wrapped
}

// Applies withSpaComponentWrapper to every entry of a Bloomreach component mapping.
export const wrapMappingWithSpaComponentWrapper = (mapping) =>
  Object.fromEntries(
    Object.entries(mapping).map(([name, Component]) => [
      name,
      withSpaComponentWrapper(Component),
    ])
  )
